import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Gift, CreditCard } from '@phosphor-icons/react';
import { toast } from 'sonner';
import api from '../api';

const Rewards = () => {
  const [rewards, setRewards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRewards();
  }, []);

  const fetchRewards = async () => {
    try {
      const response = await api.get('/rewards');
      setRewards(response.data);
    } catch (error) {
      toast.error('Failed to load rewards');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="p-6 space-y-6" data-testid="rewards-loading">
        <div className="animate-pulse space-y-4">
          <div className="h-32 bg-muted rounded-xl"></div>
          <div className="h-32 bg-muted rounded-xl"></div>
        </div>
      </div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className="p-6 space-y-6"
      data-testid="rewards-page"
    >
      {/* Header */}
      <div className="space-y-2">
        <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight">
          Rewards
        </h1>
        <p className="text-sm text-muted-foreground uppercase tracking-wider">
          Points from Latest Statements
        </p>
      </div>

      {/* Rewards List */}
      {rewards.length === 0 ? (
        <Card className="text-center p-12" data-testid="no-rewards">
          <CreditCard size={48} className="mx-auto text-muted-foreground mb-4" />
          <p className="text-muted-foreground">No reward points found. Upload statements to track rewards.</p>
        </Card>
      ) : (
        <div className="space-y-3">
          {rewards.map((reward, index) => (
            <Card key={index} data-testid="reward-card">
              <CardContent className="p-4">
                <div className="flex items-start justify-between gap-4">
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-1">
                      <CreditCard size={18} className="text-primary flex-shrink-0" weight="bold" />
                      <p className="font-semibold truncate">{reward.card_name}</p>
                    </div>
                    <p className="text-xs text-muted-foreground">
                      {reward.month}/{reward.year}
                    </p>
                  </div>
                  <div className="text-right flex-shrink-0">
                    <p className="text-xl font-bold tabular-nums text-primary">
                      {(reward.points || 0).toLocaleString('en-IN')}
                    </p>
                    <p className="text-xs text-muted-foreground">points</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}

      {/* Note */}
      <p className="text-xs text-center text-muted-foreground">
        Points shown from the most recent statement for each card
      </p>
    </motion.div>
  );
};

export default Rewards;
